// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/**\n * 全局变量\n * 命名规范 —— 遵守语义化命名：lg-大号、md-中号、base-基本号、sm-小号、mini-超小号\n */\n.filter-span[data-v-d16d6306] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n}\n.filter-span .van-icon[data-v-d16d6306] {\n  margin-left: 0.13333rem;\n}\n[data-v-d16d6306] .van-nav-bar__title {\n  font-size: 0.45333rem;\n  color: #141418;\n  font-weight: 400;\n}", ""]);
// Exports
module.exports = exports;
